import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'callback'
})
export class CallbackPipe implements PipeTransform {

//   transform(items: any[], callback: (item: any) => boolean): any {
//     if (!items || !callback) {
//         return items;
//     }
//     return items.filter(item => callback(item));
// }

transform(value: string): string {
  const splitBy = '\n'
  const splittedText = value.split( splitBy );
  return `${ splittedText[0] } ${ splitBy } <br> <b>${ splittedText[1] }</b>`;
}

}
